import { Injectable } from '@angular/core';
import { CoreService } from '../manager/core.service';
import { OfflineService } from '../manager/offline.service';
import { SessionService } from '../manager/session.service';
import { LoginService } from '../auth/login.service';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  constructor(
    private core: CoreService,
    private offline: OfflineService,
    private session: SessionService,
    private login: LoginService,
    private api: ApiService
  ) { }

  async startLogin() {
    await this.login.verifyLogin(true);
    this.renewLoginTokenInBackground();
  }

  async init() {
    await this.session.initSession();
  }

  private renewLoginTokenInBackground(): void {
    this.api.refreshLoginToken().catch((error) => {
      console.error('App-Login-Token-Erneuerung beim Start fehlgeschlagen', error);
    });
  }
}
